import Button from 'components/button';
import ClockGlyph from 'components/EmptyState/ClockGlyph';
import DrawnGlyph from 'components/EmptyState/DrawnGlyph';

/**
 * The empty state of the site, in the style of company's (`EmptyStateCompany`):
 * a glyph that draws itself in a large grey circle, a title, a line of text and
 * at most one secondary button, centred in the space of the screen. Every
 * empty state takes this layout: `EmptyState` renders its types through it.
 *
 * `glyph` names one of `drawnGlyphs.js`, or `clock` for the ticking clock of
 * ClockGlyph; the page (`fileText`) by default. `description` and `action`
 * ({ label, onClick }) are optional. `compact`: inside a slide-over or a modal,
 * with no height to centre in and the small button of the panels.
 */
const CompactEmptyState = ({
  glyph = 'fileText',
  title,
  description,
  action,
  compact = false,
}) => (
  // Full width up to its own: in a flex row (the missions list) it would
  // otherwise shrink to its text.
  <div
    className={`mx-auto flex w-full max-w-[535px] flex-col items-center justify-center text-center ${compact ? 'py-8' : 'min-h-[60vh] py-16'}`}
  >
    <div className="relative mb-5 flex h-24 w-24 items-center justify-center rounded-full bg-gray-100 text-gray-400">
      {glyph === 'clock' ? <ClockGlyph /> : <DrawnGlyph name={glyph} />}
    </div>
    <div className="!font-medium ft-b text-gray-900">{title}</div>
    {description && (
      <div className="font-normal ft-sm !leading-5 mt-2 text-[#757575]">
        {description}
      </div>
    )}
    {action && (
      <div className="my-3">
        <Button
          color="SECONDARY"
          size={compact ? 'SM' : 'LG'}
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      </div>
    )}
  </div>
);

export default CompactEmptyState;
